/**
 * Serviço de Atividades Tecnológicas
 *
 * Gerencia operações CRUD de atividades tecnológicas usando PostgREST.
 * Tabela: atividades_tecnologicas
 */

import { postgrestClient } from "../lib/postgrest/client";

/**
 * Serviço de atividades tecnológicas
 */
export const tecnologicasService = {
    /**
     * Lista atividades tecnológicas com filtros
     * @param {Object} options
     * @param {Object} options.filters - Filtros (ex: { categoria: "eq.Programação" })
     * @param {string} options.order - Ordenação (ex: "nome.asc")
     * @param {number} options.limit - Limite de resultados
     * @param {number} options.offset - Offset para paginação
     * @param {boolean} options.includeCount - Se true, retorna { data, total }
     * @returns {Promise<Array|{data: Array, total: number}>}
     */
    async list(options = {}) {
        const { filters = {}, order = "nome.asc", limit, offset, includeCount = false } = options;
        const result = await postgrestClient.get("atividades_tecnologicas", {
            filters,
            order,
            limit,
            offset,
            includeCount,
        });

        // Se includeCount, retorna { data, total }, senão retorna array direto
        if (includeCount && result && typeof result === 'object' && 'data' in result) {
            return result;
        }
        return result;
    },

    /**
     * Busca atividade tecnológica por ID
     * @param {string} id
     * @returns {Promise<Object>}
     */
    async getById(id) {
        const result = await postgrestClient.get("atividades_tecnologicas", {
            filters: { id: `eq.${id}` },
        });
        return Array.isArray(result) ? result[0] : result;
    },

    /**
     * Cria nova atividade tecnológica
     * @param {Object} atividadeData
     * @returns {Promise<Object>}
     */
    async create(atividadeData) {
        const result = await postgrestClient.post("atividades_tecnologicas", atividadeData);
        return Array.isArray(result) ? result[0] : result;
    },

    /**
     * Atualiza atividade tecnológica
     * @param {string} id
     * @param {Object} atividadeData
     * @returns {Promise<Object>}
     */
    async update(id, atividadeData) {
        const result = await postgrestClient.patch("atividades_tecnologicas", { id }, atividadeData);
        return Array.isArray(result) ? result[0] : result;
    },

    /**
     * Remove atividade tecnológica
     * @param {string} id
     * @returns {Promise<null>}
     */
    async delete(id) {
        return postgrestClient.delete("atividades_tecnologicas", { id });
    },
};

export default tecnologicasService;
